var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09604 4.77132C1.24338 4.91709 1.44227 4.99885 1.64954 4.99885C1.8568 4.99885 2.0557 4.91709 2.20304 4.77132L5.02004 1.99832L7.79904 4.77132C7.87199 4.844 7.95854 4.90161 8.05375 4.94085C8.14896 4.98008 8.25097 5.00018 8.35395 5C8.45693 4.99981 8.55887 4.97935 8.65394 4.93977C8.74901 4.90018 8.83535 4.84227 8.90804 4.76932C8.98072 4.69637 9.03833 4.60982 9.07757 4.5146C9.1168 4.41939 9.1369 4.31738 9.13672 4.2144C9.13653 4.11142 9.11606 4.00949 9.07648 3.91442C9.0369 3.81935 8.97899 3.733 8.90604 3.66032L5.57804 0.343317C5.50492 0.269935 5.41804 0.21171 5.32237 0.171981C5.2267 0.132252 5.12413 0.111802 5.02054 0.111802C4.91695 0.111802 4.81437 0.132252 4.71871 0.171981C4.62304 0.21171 4.53615 0.269935 4.46304 0.343317L1.09604 3.66032C1.02241 3.73289 0.96395 3.81937 0.924047 3.91473C0.884143 4.0101 0.863594 4.11244 0.863594 4.21582C0.863594 4.31919 0.884143 4.42154 0.924047 4.5169C0.96395 4.61227 1.02241 4.69875 1.09604 4.77132Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/AngleUp.23e0bae8.svg";
export { ForwardRef as ReactComponent };